import React, { useEffect, useState } from 'react';

/**
 * Skeleton específico para a Landing Page
 * Usa cores fixas light mode para manter consistência visual
 * Com animação de fade-in suave
 */
export const LandingSkeleton = () => {
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Trigger fade-in animation after mount
    const timer = requestAnimationFrame(() => setIsVisible(true));
    return () => cancelAnimationFrame(timer);
  }, []);

  return (
    <div 
      className="min-h-screen transition-opacity duration-300"
      style={{ 
        backgroundColor: '#ffffff',
        opacity: isVisible ? 1 : 0
      }}
    >
      {/* Header skeleton */}
      <header 
        className="sticky top-0 z-50 border-b"
        style={{ backgroundColor: '#ffffff', borderColor: '#e5e7eb' }}
      >
        <div className="container mx-auto px-4 h-16 flex items-center justify-between">
          {/* Logo */}
          <div 
            className="h-8 w-32 rounded animate-pulse" 
            style={{ backgroundColor: '#e5e7eb' }}
          />
          
          {/* Nav items */}
          <div className="hidden md:flex items-center gap-6">
            {[1, 2, 3, 4].map((i) => (
              <div 
                key={i}
                className="h-4 w-20 rounded animate-pulse" 
                style={{ backgroundColor: '#f3f4f6' }}
              />
            ))}
          </div>
          
          {/* CTA buttons */}
          <div className="flex items-center gap-3">
            <div 
              className="h-9 w-20 rounded-lg animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
            <div 
              className="h-9 w-24 rounded-lg animate-pulse" 
              style={{ backgroundColor: '#3b82f6' }}
            />
          </div>
        </div>
      </header>

      {/* Hero section skeleton */}
      <section className="py-20 px-4">
        <div className="container mx-auto max-w-4xl text-center space-y-8">
          {/* Badge */}
          <div className="flex justify-center">
            <div 
              className="h-6 w-48 rounded-full animate-pulse" 
              style={{ backgroundColor: '#dbeafe' }}
            />
          </div>
          
          {/* Main heading */}
          <div className="space-y-4">
            <div 
              className="h-12 w-3/4 mx-auto rounded animate-pulse" 
              style={{ backgroundColor: '#e5e7eb' }}
            />
            <div 
              className="h-12 w-1/2 mx-auto rounded animate-pulse" 
              style={{ backgroundColor: '#e5e7eb' }}
            />
          </div>
          
          {/* Subheading */}
          <div className="space-y-2 max-w-2xl mx-auto">
            <div 
              className="h-5 w-full rounded animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
            <div 
              className="h-5 w-4/5 mx-auto rounded animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
          </div>
          
          {/* CTA buttons */}
          <div className="flex justify-center gap-4 pt-4">
            <div 
              className="h-12 w-40 rounded-lg animate-pulse" 
              style={{ backgroundColor: '#3b82f6' }}
            />
            <div 
              className="h-12 w-36 rounded-lg animate-pulse" 
              style={{ backgroundColor: '#f3f4f6' }}
            />
          </div>
        </div>
      </section>

      {/* Features preview skeleton */}
      <section className="py-16 px-4" style={{ backgroundColor: '#f9fafb' }}>
        <div className="container mx-auto max-w-6xl">
          <div className="grid md:grid-cols-3 gap-8">
            {[1, 2, 3].map((i) => (
              <div 
                key={i}
                className="p-6 rounded-xl"
                style={{ backgroundColor: '#ffffff' }}
              >
                <div 
                  className="h-12 w-12 rounded-lg mb-4 animate-pulse" 
                  style={{ backgroundColor: '#dbeafe' }}
                />
                <div 
                  className="h-6 w-3/4 rounded mb-2 animate-pulse" 
                  style={{ backgroundColor: '#e5e7eb' }}
                />
                <div className="space-y-2">
                  <div 
                    className="h-4 w-full rounded animate-pulse" 
                    style={{ backgroundColor: '#f3f4f6' }}
                  />
                  <div 
                    className="h-4 w-5/6 rounded animate-pulse" 
                    style={{ backgroundColor: '#f3f4f6' }}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  );
};

export default LandingSkeleton;
